import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=79c91db0&"
import script from "./Sponsorship.vue?vue&type=script&setup=true&lang=js&"
export * from "./Sponsorship.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports